import timeSelect from './timeSelect'
const component = {
  install: function(Vue) {
    Vue.component('time-select', timeSelect)
  }
}
export default component
